function normalizeUrlForValidation(url: string): string {
  let normalized = url.trim();

  if (!normalized.startsWith('/')) {
    normalized = normalized.replace(/^\/+|\/+$/g, '');
  }

  return normalized;
}

function isSafeUrlParam(param: string | null | undefined, whiteList: string[]): boolean {
  if (!param) {
    return true;
  }
  const relativePathRegex = /^(\/[a-zA-Z0-9\-._~!$&'()*+,;=:@%]*)*$/;

  if (relativePathRegex.test(param)) {
    return true;
  }

  const cleanParam = param
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    .toLowerCase();

  return whiteList.some(
    (domain) => cleanParam === domain.toLowerCase() || cleanParam.endsWith(`.${domain.toLowerCase()}`)
  );
}

export function isSafeUrlParamStrict(param: string | null | undefined, whiteList: string[]): boolean {
  if (!param) {
    return false;
  }

  const normalized = normalizeUrlForValidation(param);

  if (normalized.startsWith('//')) {
    return false;
  }

  // eslint-disable-next-line no-script-url
  if (normalized.toLowerCase().startsWith('javascript:')) {
    return false;
  }

  if (normalized.startsWith('/') && !normalized.includes('://')) {
    return !normalized.includes('../') && !normalized.includes('..\\');
  }

  return isSafeUrlParam(normalized, whiteList);
}
